<template>
  <div class="user-settings page">
    <h1 class="title is-4">
      {{ user.firstName }} {{ user.lastName }}
    </h1>

    <template v-if="!changingPassword">
      <button class="button" @click="changingPassword = true">Change Password</button>
    </template>
    <template v-else>
      <div class="columns" style="margin-top: 10px">
        <div class="column is-half">
          <div class="box">
            <h2 class="title is-6">Change Password</h2>
            <form @submit.prevent="updatePassword" autocomplete="off">
              <input autocomplete="off" name="hidden" type="text" style="display:none;">
              <input autocomplete="off" name="hidden" type="password" style="display:none;">
              <b-field>
                <b-input autocomplete="off" v-model="newPassword" placeholder="new password" type="password"></b-input>
              </b-field>
              <b-field>
                <b-input autocomplete="off" v-model="confirmPassword" placeholder="confirm password" type="password"></b-input>
              </b-field>
              <div v-if="changePasswordMsg.length" class="notification">
                {{ changePasswordMsg }}
              </div>
              <button type="submit" class="button is-info" :class="{'is-loading': loadingChangePassword}">Update</button>
              <button class="button" @click="changingPassword = false">Cancel</button>
            </form>
          </div>
        </div>
      </div>
    </template>

    <div class="columns" style="margin-top: 10px">
      <div class="column is-half">
        <div class="box">
          <h2 class="title is-6">Settings</h2>
          <div v-for="(obj, key) of settings" :key="key">
            <template v-if="obj.type === 'boolean'">
              <div class="field">
                <b-checkbox v-model="obj.value" @input="updateSettings">
                  {{ $utils.camelToSpaces(key) }}
                </b-checkbox>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserSettings',
  data () {
    return {
      newPassword: '',
      confirmPassword: '',
      changingPassword: false,
      loadingChangePassword: false,
      changePasswordMsg: ''
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    settings () { return this.$store.getters.settings }
  },
  methods: {
    updatePassword () {
      this.changePasswordMsg = ''
      if (this.newPassword !== this.confirmPassword) {
        this.changePasswordMsg = 'Passwords do not match!'
      } else {
        this.loadingChangePassword = true
        console.log(this.$firebase)
        let currentUser = this.$firebase.auth().currentUser
        if (currentUser) {
          currentUser.updatePassword(this.newPassword)
            .then(() => {
              this.loadingChangePassword = false
              this.changePasswordMsg = 'Password Changed!'
              setTimeout(() => {
                this.changePasswordMsg = ''
                this.newPassword = ''
                this.confirmPassword = ''
                this.changingPassword = false
              }, 1500)
            })
            .catch(error => {
              console.log(error)
              this.loadingChangePassword = false
              this.changePasswordMsg = `ERROR: ${error.message}`
            })
        } else {
          this.loadingChangePassword = false
          this.changePasswordMsg = 'Current user invalid?'
        }
      }
    },
    updateSettings () {
      this.$store.dispatch('setSettings', this.settings)
    }
  }
}
</script>
